import styled from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import { WORKSPACE_TOPBAR_HEIGHT } from 'common/styles/variables';
import * as Tabs from '@radix-ui/react-tabs';
import { GuestExperienceContainer } from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const AgendaGuestExperienceContainer = styled(GuestExperienceContainer)`
    ${({ $previewing }) => $previewing && `height: calc(100% - ${WORKSPACE_TOPBAR_HEIGHT})`}
`;

export const CoverLinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;

    ${mediaMaxWidth.large`
        gap: 1.5rem
    `}
`;

export const BlockContentContainer = styled.div`
    max-width: 770px;
    font-size: 1.25rem;
    text-align: center;
`;

export const SessionsNavigationBlockContentContainer = styled(BlockContentContainer)`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 220px;
    grid-template-areas:
        'search filter'
        'tabs ...'
        'add-to-calendar ...';
    gap: 1.5rem;

    ${mediaMaxWidth.large`
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    `}

    ${mediaMaxWidth.medium`
        grid-template-columns: 1fr;
        grid-template-areas:
            'search'
            'filter'
            'tabs'
            'add-to-calendar';
        gap: 1.5rem;
    `}
`;

// Keep this in parity with cms-footer.styl until we make this user editable
// Disable ESLint for SUI Variables because we don't want this attached to SUI
/* eslint-disable @splashthat/sui-colors-only */
export const ContactTheOrganizerContainer = styled.div`
    background-color: #1a1a1a;
    color: #ffffff;
    padding: 2rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    a {
        border: none;
        outline-style: none;
        font: inherit;
        background: none;
        cursor: pointer;

        font-size: 13px;
        line-height: 1.5;
        letter-spacing: 1px;
        color: #ffffff;
        font-family: Lato, sans-serif;
        font-weight: 700;
        border-radius: 2px;
        transition: all 500ms linear;
        padding: 0 0.5rem;

        &:hover,
        &:active {
            color: #1a1a1a;
            background: #e5e5e5;
            transition: none;
        }

        &:focus {
            outline-style: auto;
        }
    }
`;

export const LoadingSpinnerContainer = styled.div`
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center;
`;

export const StyledTabsRoot = styled(Tabs.Root)`
    display: flex;
    flex-direction: column;
`;

export const StyledTabsContent = styled(Tabs.Content)`
    width: 100%;
    max-width: 770px;
`;

export const StyledTabsTrigger = styled(Tabs.Trigger)`
    font-family: inherit;
    background-color: inherit;
    border-color: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    color: inherit;
    padding-bottom: 1rem;
    border-width: 0;
    &[data-state='active'],
    &:hover {
        border-bottom-width: 2px;
    }
    :hover {
        cursor: pointer;
    }
`;

export const StyledTabsList = styled(Tabs.List)`
    flex-shrink: 0;
    display: flex;
    border-bottom: 1px solid var(--mauve-6);
    justify-content: left;
    gap: 1rem;
    padding: 0px 1rem 1rem;
    width: 100%;
    max-width: 770px;
`;
